export default __webpack_public_path__ + "static/admin3-f5cb41da19ce5e8be23b55b8144bd9a8.png";